import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  listIcon: {
    marginRight: theme.spacing(),
  },
  socialIcon: {
    marginRight: 0,
  },
  secondaryAction: {
    paddingRight: theme.spacing(7),
  },
  iconButton: {
    padding: 0,
  },
  peopleIcon: {
    fontSize: 28,
  },
  updateIcon: {
    fontSize: 28,
    color: theme.palette.error.main,
  },
  connect: {
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  overflow: theme.mixins.overflowText(),
}));

export default styles;
